var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.0675C18.9997 15.9852 18.6959 16.8753 18.1388 17.5905C17.5817 18.3056 16.8047 18.8029 15.9366 19L15.5218 17.7156C15.9016 17.651 16.2628 17.5002 16.5793 17.2742C16.8958 17.0481 17.1598 16.7524 17.3523 16.4083H15.75C15.4052 16.4083 15.0746 16.2669 14.8308 16.0152C14.587 15.7635 14.45 15.4221 14.45 15.0661V12.3818C14.45 12.0259 14.587 11.6845 14.8308 11.4328C15.0746 11.1811 15.4052 11.0397 15.75 11.0397H17.6597C17.5011 9.74243 16.8894 8.54951 15.9394 7.68476C14.9895 6.82001 13.7665 6.34288 12.5 6.34288C11.2335 6.34288 10.0105 6.82001 9.06057 7.68476C8.1106 8.54951 7.49892 9.74243 7.3403 11.0397H9.25C9.59478 11.0397 9.92544 11.1811 10.1692 11.4328C10.413 11.6845 10.55 12.0259 10.55 12.3818V15.0661C10.55 15.4221 10.413 15.7635 10.1692 16.0152C9.92544 16.2669 9.59478 16.4083 9.25 16.4083H7.3C6.95522 16.4083 6.62456 16.2669 6.38076 16.0152C6.13696 15.7635 6 15.4221 6 15.0661V11.7108C6 8.00441 8.91005 5 12.5 5C16.09 5 19 8.00441 19 11.7108V15.0675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFilledIcon);
export default __webpack_public_path__ + "static/media/contact-filled-icon.90dbf4e259b62d79da7b69083debb803.svg";
export { ForwardRef as ReactComponent };